import { ProviderActivationStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderActivationQuery } from '@uplift/queries';


export const useGoLiveLocked = () => {
  const me = useCurrentuser();
  const { data: activation, isLoading } = useProviderActivationQuery(me?.id);

  const locked = isLoading || !activation || activation.status === ProviderActivationStatus.live;

  return { locked, isLoading };
};
